import type { DateTime } from '@ksyos/date-time';
import type { IProcess } from 'common/interfaces/IProcess';
import type { IProcessAction } from 'common/interfaces/IProcessAction';
import type { IRequest } from 'common/interfaces/IRequest';
import type { InsuranceHistory } from 'common/interfaces/patientInsurance';
import type { IAuthenticatedUser } from 'common/utils/IAuthenticatedUser';
import type { Dispatch } from 'react';
import type { IUserPermissions } from './reducers';
import { fetch } from '../fetch';
export const AUTHENTICATION_LOGGED_IN = 'AUTHENTICATION_LOGGED_IN';
export const AUTHENTICATION_LOGOUT = 'AUTHENTICATION_LOGOUT';
export const AUTHENTICATION_CHECKING = 'AUTHENTICATION_CHECKING';
export const AUTHENTICATION_CHECKING_FAILED = 'AUTHENTICATION_CHECKING_FAILED';
export const USER_ACTIONS_CHANGED = 'USER_ACTIONS_CHANGED';
export const USER_PERMISSIONS_CHANGED = 'USER_PERMISSIONS_CHANGED';
export const USER_DATA_CHANGED = 'USER_DATA_CHANGED';
export const USER_PROCESSES_CHANGED = 'USER_PROCESSES_CHANGED';
export const USER_REQUEST_PROCESSES_CHANGED = 'USER_REQUEST_PROCESSES_CHANGED';
export const USER_INSURANCE_CHANGED = 'USER_INSURANCE_CHANGED';
export const SESSION_TIMEOUT_CHANGED = 'SESSION_TIMEOUT_CHANGED';
export const USER_HAS_OSAS_MRA_REFERRAL_LETTER_CHANGED = 'USER_OSAS_MRAREFERRAL_LETTER_CHANGED';

function checkingFailed() {
    return { type: AUTHENTICATION_CHECKING_FAILED };
}

function checking() {
    return { type: AUTHENTICATION_CHECKING };
}

export function receiveLogin(json: any) {
    return (dispatch: any) => {
        dispatch({
            type: AUTHENTICATION_LOGGED_IN,
            user: json,
        });
    };
}

export function receiveUserProcesses(processes: IProcess[]) {
    return (dispatch: Dispatch<{ processes: IProcess[]; type: typeof USER_PROCESSES_CHANGED }>) => {
        dispatch({
            processes,
            type: USER_PROCESSES_CHANGED,
        });
    };
}

export function receiveUserInsurance(insurance: InsuranceHistory) {
    return (dispatch: Dispatch<{ insurance: InsuranceHistory; type: typeof USER_INSURANCE_CHANGED }>) => {
        dispatch({
            insurance,
            type: USER_INSURANCE_CHANGED,
        });
    };
}

export function receiveUserRequestProcesses(requestProcesses: IRequest[]) {
    return (dispatch: Dispatch<{ requestProcesses: IRequest[]; type: typeof USER_REQUEST_PROCESSES_CHANGED }>) => {
        dispatch({
            requestProcesses,
            type: USER_REQUEST_PROCESSES_CHANGED,
        });
    };
}

export function receiveUserActions(actions: IProcessAction[]) {
    return (dispatch: Dispatch<{ actions: IProcessAction[]; type: typeof USER_ACTIONS_CHANGED }>) => {
        dispatch({
            actions,
            type: USER_ACTIONS_CHANGED,
        });
    };
}

export function receiveUserPermissions(permissions: Partial<IUserPermissions>) {
    return (dispatch: Dispatch<{ permissions: Partial<IUserPermissions>; type: 'USER_PERMISSIONS_CHANGED' }>) => {
        dispatch({
            permissions,
            type: USER_PERMISSIONS_CHANGED,
        });
    };
}

export function receiveUserOsasMraReferralLetter(userHasOsasMraReferralLetter: boolean) {
    return (
        dispatch: Dispatch<{
            type: typeof USER_HAS_OSAS_MRA_REFERRAL_LETTER_CHANGED;
            userHasOsasMraReferralLetter: boolean;
        }>
    ) => {
        dispatch({
            type: USER_HAS_OSAS_MRA_REFERRAL_LETTER_CHANGED,
            userHasOsasMraReferralLetter,
        });
    };
}

export function receiveUserData(user: Partial<IAuthenticatedUser>) {
    return (
        dispatch: Dispatch<{
            type: typeof USER_DATA_CHANGED;
            user: Partial<IAuthenticatedUser>;
        }>
    ) => {
        dispatch({
            type: USER_DATA_CHANGED,
            user,
        });
    };
}

export function fetchAuthenticationAction(relayState?: string) {
    return (dispatch: any) => {
        dispatch(checking());
        let url = '/api/session';
        if (relayState) {
            url += `?relayState=${encodeURIComponent(relayState)}`;
        }

        return fetch(url, 'GET').then(async (response: any) => {
            if (response.status === 403) {
                dispatch(checkingFailed());
                url = '/saml/login';
                const json = await response.json();
                if (json.relayUuid) {
                    url += `?relayState=${json.relayUuid}`;
                }
                window.location.replace(url);
            } else if (response.status >= 400) {
                console.log(response);
            } else {
                let cleanerUrl = window.location.href;
                cleanerUrl = cleanerUrl.replace(/(?<=&|\?)utm_[^=]+=[^&]+&?/g, ''); // remove utm_key=value
                cleanerUrl = cleanerUrl.replace(/\?$/, ''); // remove trailing question mark
                window.history.replaceState({}, '', cleanerUrl);

                return response.json().then((json: any) => dispatch(receiveLogin(json)));
            }
        });
    };
}

export function logout() {
    return (_dispatch: unknown) => {
        return fetch('/api/session', 'DELETE')
            .then((response: any) => response.json())
            .then((_json: unknown) => {
                window.location.href = '/';
            });
    };
}

export function receiveSessionTimeout(timeout: DateTime) {
    return (dispatch: any) => {
        dispatch({
            timeout,
            type: SESSION_TIMEOUT_CHANGED,
        });
    };
}
